import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteScenario = {
  name: "deleteScenario" as const,
  input: z.object({ scenarioId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
